import { useMemo } from 'react';
import sortBy from 'lodash/sortBy';

import SubActivityPrint from '../sub-activity/sub-activity-print';
import { getRichtextAnswer } from '../shared/logic/get-richtext-answer';
import { useActivityAnswersPrintContext } from 'approot/activity-builder/print/answers/activity-answers-print.context';
import { useResponseBaseHeight } from './response.hooks';
import { ViewProps } from './response.constants';
import ResponseFieldReadonly from './response-field-readonly';
import * as Styled from './response-print-answer.style';

const ResponsePrintAnswer = ({
  id,
  properties,
  subActivityProperties,
  studentId,
}: ViewProps & {
  studentId?: number;
}) => {
  const { answers: sourceAnswers } = useActivityAnswersPrintContext(id);

  const answers = useMemo(
    () =>
      studentId
        ? sourceAnswers?.filter(a => a.studentId === studentId)
        : sourceAnswers,
    [sourceAnswers, studentId]
  );

  const baseHeight = useResponseBaseHeight();
  const sortedFields = useMemo(
    () => sortBy(properties.textResponse.fields, 'sort'),
    [properties.textResponse.fields]
  );
  return (
    <SubActivityPrint subActivityDetails={subActivityProperties}>
      <Styled.ResponsePrintAnswerContainer>
        {sortedFields.map(field => {
          const answer = answers.find(
            a => a.answerReferences?.id === field.itemId
          );
          return (
            <ResponseFieldReadonly
              key={field.itemId}
              answer={getRichtextAnswer(answer)}
              baseHeight={baseHeight}
              field={field}
            />
          );
        })}
      </Styled.ResponsePrintAnswerContainer>
    </SubActivityPrint>
  );
};
export default ResponsePrintAnswer;
